'use client';

import type { ReactNode } from 'react';
import { cn } from '../_lib/utils';
import { isValidRichText } from '../_lib/isValidRichText';
import { Chip } from '../Chip';
import { Divider } from '../Divider';
import { Text } from '../Text';

export type ContentHeaderProps = {
	className?: string;
	label?: string;
	title: ReactNode;
	copy?: ReactNode;
	updated?: ReactNode;
	chips?: string[];
};

export function ContentHeader(props: ContentHeaderProps) {
	return (
		<article
			data-component='ContentHeader'
			className={cn('container-md flex flex-col gap-4 w-full no-nested-containers md:gap-6', props.className)}
		>
			{props.label && (
				<Text as='h4' className='opacity-80' styleType='label-sm'>
					{props.label}
				</Text>
			)}
			<Text as='h2' className={`max-w-[42.5rem]`} styleType='heading-md'>
				{props.title}
			</Text>
			{isValidRichText(props.copy) && (
				<Text className={'max-w-[38.75rem]'} styleType='editorial-lg'>
					{props.copy}
				</Text>
			)}
			{isValidRichText(props.updated) && (
				<Text className={'opacity-60'} styleType='body-sm-medium'>
					{props.updated}
				</Text>
			)}
			{props.chips && (
				<div className={'flex flex-row gap-2'}>
					{props.chips.map((chip, index) => (
						<Chip key={`chip-${chip}-${index}`}>{chip}</Chip>
					))}
				</div>
			)}
			<Divider />
		</article>
	);
}
